import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import CargomaticCard from 'components/v2/card';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import EditReferenceNumbersModal from 'components/modules/shipments/EditReferenceNumbersModal';
import DataPoller from 'components/ui/DataPoller';
import Alert from 'components/ui/tailwind/Alert';
import ArrivedModal from 'components/ui/tailwind/modals/ArrivedModal';
import OrderShipmentsStore from 'stores/OrderShipmentsStore';
import { withTranslation } from 'react-i18next';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import OrdersStore from '../../../stores/OrdersStore';
import SessionStore from '../../../stores/SessionStore';
import StatusBar from './StatusBar';
import OrderMap from './OrderMap';
import { OrderDocuments } from './OrderDocuments';
import CommentList from '../comments/CommentList';
import InboundDetails from './OrderDetails';
import ReferenceNumbers from './ReferenceNumbers';
import { OrderShipments } from './leg-management';
import ShipmentsList from './ShipmentsList';
import EquipmentsList from './EquipmentsList';
import AccountsPayable from './AccountsPayable';
import AccountsReceivable from './AccountsReceivable';
import AccessorialsList from './AccessorialsList';
import BulkAddAccessorialsModal from '../shipments/accounting/BulkAddAccessorialsModal';
import OrderRtbSummary from 'components/modules/shipments/accounting/OrderRtbSummary';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { isDrayageShipment } from '../../../helpers/shipment-types';
import HazmatDetails from './HazmatDetailsList';
const POLLING_FREQ = 30000;
const shipmentQueryOptions = {
    paginate: true,
    per_page: 15,
    page: 1,
};
// Functional gate for LD flag usage inside class component
function OrderRtbSummaryGate() {
    const flags = useFlags();
    if (!(flags === null || flags === void 0 ? void 0 : flags.orderRtb))
        return null;
    return React.createElement(OrderRtbSummary, null);
}
class Module extends Component {
    constructor(props) {
        super(props);
        this.handleOrderShipmentsStoreChange = () => {
            const orderShipments = OrderShipmentsStore.getOrderShipments();
            this.updateShipmentsState(orderShipments);
        };
        this.handleOrdersStoreChange = () => {
            const order = OrdersStore.getOrder();
            const audits = OrdersStore.getAudits();
            if (!this.state.title && order && order.order_id) {
                document.title = order.order_id;
                this.setState({ title: order.order_id });
            }
            const shipmentsWithZeroValueAccessorials = this.getShipmentsWithZeroValueAccessorials(order);
            this.setState({
                order,
                shipmentsWithZeroValueAccessorials,
                hasZeroValueAccessorials: shipmentsWithZeroValueAccessorials.length > 0,
                audits,
            });
        };
        this.handleStagingShipmentsChange = () => {
            const stagingShipments = OrdersStore.getStagingShipments();
            if (!stagingShipments) {
                return;
            }
            this.setState({ stagingShipments });
        };
        this.handleCommentAdd = (comment) => {
            const { order: { _id: orderId }, } = this.state;
            OrdersActionCreators.addComment(orderId, comment);
        };
        this.handleAddBulkAccessorialsClick = () => this.setState({ showBulkAddAccessorialsModal: true });
        this.handleSessionStoreChange = () => {
            const hasFinanceRole = SessionStore.hasFinanceRole();
            this.setState({
                hasFinanceRole,
            });
        };
        this.onGetOrderShipments = () => {
            const orderId = this.props.id || this.props.match.params.id;
            const options = Object.assign(Object.assign({}, shipmentQueryOptions), { page: this.state.shipmentListPagination.currentPage || 1 });
            OrdersActionCreators.getOrderShipments(orderId, options);
        };
        this.handleShipmentListPagination = (eventKey) => {
            const paginationData = OrderShipmentsStore.getOrderShipmentPaginationData();
            this.setState({
                shipmentListPagination: {
                    currentPage: eventKey,
                    totalPages: paginationData.pages,
                },
            }, this.onGetOrderShipments);
        };
        const hasFinanceRole = SessionStore.hasFinanceRole();
        this.state = {
            order: null,
            title: '',
            shipmentsWithZeroValueAccessorials: [],
            audits: [],
            showEditReferenceNumbersModal: false,
            showArrivedModal: false,
            showBulkAddAccessorialsModal: false,
            hasFinanceRole,
            stagingShipments: [],
            bookedShipments: [],
            shipmentListPagination: {},
        };
    }
    componentDidMount() {
        OrdersActionCreators.getOrderShipments(this.props.id || this.props.match.params.id, shipmentQueryOptions);
        OrderShipmentsStore.addChangeListener(this.handleOrderShipmentsStoreChange);
        OrdersStore.addStagingShipmentsChangeListener(this.handleStagingShipmentsChange);
        OrdersStore.addChangeListener(this.handleOrdersStoreChange);
        SessionStore.addChangeListener(this.handleSessionStoreChange);
        this.handleStagingShipmentsChange();
    }
    componentWillUnmount() {
        OrdersStore.removeChangeListener(this.handleOrdersStoreChange);
        SessionStore.removeChangeListener(this.handleSessionStoreChange);
        OrdersActionCreators.resetStagingShipments();
        OrdersActionCreators.resetOrderShipments();
    }
    getOrder() {
        const { order } = this.state;
        return order || {};
    }
    getShipments() {
        return this.state.bookedShipments || [];
    }
    getShipmentsWithZeroValueAccessorials(order) {
        if (!order) {
            return [];
        }
        const orderShipments = this.state.bookedShipments || [];
        return orderShipments.filter((job) => {
            const receivables = job.receivables || [];
            const payables = job.payables || [];
            const zeroCostAR = receivables.filter((s) => s.value === 0);
            const zeroCostAP = payables.filter((s) => s.value === 0);
            return zeroCostAR.length > 0 || zeroCostAP > 0;
        });
    }
    updateReferenceNumbers(references) {
        OrdersActionCreators.updateOrder(this.state.order._id, {
            reference_numbers: references,
        });
        this.setState({
            showEditReferenceNumbersModal: false,
        });
    }
    updateOrderHazmatDetails(orderId, hazmatDetails) {
        OrdersActionCreators.updateOrder(orderId, {
            hazmat_details: hazmatDetails,
        });
    }
    renderMissingDocumentation() {
        const drayageShipmentsMissingDocumentation = this.getShipments().filter((s) => isDrayageShipment(s) && s.missing_docs);
        if (this.state.order &&
            !this.state.order.missing_docs &&
            drayageShipmentsMissingDocumentation.length === 0)
            return null;
        const { t } = this.props;
        return (React.createElement(Alert, { dataTestId: "Alert-564a51e7", status: "red", message: t('MISSING_DOC_FOR_ORDER') }));
    }
    renderOutstandingARStatus() {
        const { order: { outstanding_ar, outstanding_ap }, } = this.state;
        if (!outstanding_ar && !outstanding_ap) {
            return null;
        }
        const { t } = this.props;
        return (React.createElement(Alert, { dataTestId: "Alert-29539371", status: "yellow", message: t('OUTSTANDING_BALANCE_FOR_ORDER') }));
    }
    renderZeroBalanceNotification() {
        if (!this.state.hasZeroValueAccessorials) {
            return null;
        }
        const { shipmentsWithZeroValueAccessorials: jobs } = this.state;
        const { t } = this.props;
        return (React.createElement(Alert, { dataTestId: "Alert-8cebe271", status: "yellow", message: t('NO_ACCESSORIAL_RATE_OR_COST_FOR_SHIPMENT') },
            React.createElement("ul", { "data-testid": "ul-ac3107c2" }, jobs.map((job, index) => {
                const jobLink = `/shipments/${job._id}`;
                return (React.createElement("li", { "data-testid": `li-e2b97ba0-${index}`, className: "mb-2", key: job._id },
                    React.createElement("a", { "data-testid": `a-90bccd1b-${index}`, href: jobLink }, job.shipment_id)));
            }))));
    }
    getShipmentsEligibleForAccessorialsManagement() {
        return this.getShipments().filter((s) => {
            return !_.isEmpty(s.carrier);
        });
    }
    updateShipmentsState(bookedShipments) {
        this.setState((prevState) => {
            const { stagingShipments, shipmentListPagination: currentPagination } = prevState;
            const shipments = [...stagingShipments, ...bookedShipments];
            const pagination = OrderShipmentsStore.getOrderShipmentPaginationData();
            const shipmentListPagination = {
                totalPages: pagination.pages,
                currentPage: currentPagination.currentPage || 1,
            };
            return {
                bookedShipments,
                shipments,
                shipmentListPagination,
            };
        });
    }
    render() {
        const { order, bookedShipments, stagingShipments } = this.state;
        const id = this.props.id || this.props.match.params.id;
        const { hideMap, renderedInModal, t } = this.props;
        return (React.createElement("div", { "data-testid": "div-95433961", className: "m-0 mx-auto my-8 max-w-screen-2xl" },
            React.createElement(DataPoller, { dataTestId: "DataPoller-143d43d3", action: () => OrdersActionCreators.getOrder(id), frequency: POLLING_FREQ }),
            React.createElement(DataPoller, { dataTestId: "DataPoller-cd654e78", action: () => OrdersActionCreators.getOrderAudits(id), frequency: POLLING_FREQ }),
            React.createElement(DataPoller, { dataTestId: "DataPoller-af62a7e5", action: this.onGetOrderShipments, frequency: POLLING_FREQ }),
            order && order._id && (React.createElement("div", { "data-testid": "div-889d6180", id: "order-details-container" },
                this.renderMissingDocumentation(),
                this.renderOutstandingARStatus(),
                this.renderZeroBalanceNotification(),
                React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-29de49d5", className: "", removeHorizontalPadding: true, removeVerticalPadding: true },
                    React.createElement(StatusBar, { order: order, shipments: bookedShipments, onArrivedClick: () => this.setState({ showArrivedModal: true }) }),
                    !hideMap && (React.createElement("div", { "data-testid": "div-9c2d5406", className: "my-2" },
                        React.createElement(OrderMap, { arriving: order.arriving, delivering: order.delivering })))),
                React.createElement("div", { "data-testid": "div-f11b63c0", className: "mt-5 grid sm:grid-cols-12 sm:gap-6" },
                    React.createElement("div", { "data-testid": "div-9f2bf684", className: "sm:col-span-4" },
                        React.createElement(InboundDetails, { order: order, onEdit: (edit) => {
                                OrdersActionCreators.updateOrder(order._id, edit);
                            } })),
                    React.createElement("div", { "data-testid": "div-f6319b88", className: "sm:col-span-4" },
                        React.createElement(ReferenceNumbers, { order: order, onEdit: () => {
                                this.setState({ showEditReferenceNumbersModal: true });
                            } })),
                    React.createElement("div", { "data-testid": "div-d2d86e6e", className: "sm:col-span-4 space-y-6" },
                        React.createElement(OrderDocuments, { order: order, shipments: bookedShipments }),
                        React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-e64798ff", header: () => (React.createElement("h3", { "data-testid": "h3-67608da1", className: "my-0" }, t('NOTE', { count: 2 }))) },
                            React.createElement(CommentList, { comments: order.comments, onCommentAdd: this.handleCommentAdd })))),
                React.createElement("div", { "data-testid": "div-a7e55760", className: "my-6" },
                    React.createElement(HazmatDetails, { order: order, updateOrderHazmatDetails: this.updateOrderHazmatDetails, isEditable: true })),
                React.createElement("div", { "data-testid": "div-a7e55759", className: "my-6" },
                    React.createElement(EquipmentsList, { order: order, shipments: bookedShipments })),
                React.createElement(OrderShipments, { orderId: id, order: order }),
                React.createElement(ShipmentsList, { order: order, bookedShipments: bookedShipments, stagingShipments: stagingShipments, renderedInModal: renderedInModal, onGetPaginatedShipments: this.handleShipmentListPagination, paginationData: this.state.shipmentListPagination }),
                React.createElement("div", { className: "my-6" },
                    React.createElement(OrderRtbSummaryGate, { order: order })),
                React.createElement("div", { "data-testid": "div-99fac929", className: "my-6 grid sm:grid-cols-6 sm:gap-x-4 sm:gap-y-6" },
                    React.createElement("div", { "data-testid": "div-da1c08a7", className: "sm:col-span-4" },
                        React.createElement("div", { "data-testid": "div-89a19554", className: "grid sm:grid-cols-2 sm:gap-x-4 sm:gap-y-6" },
                            React.createElement("div", { "data-testid": "div-1067acea", className: "sm:col-span-1" },
                                React.createElement(AccountsReceivable, { order: order, shipments: bookedShipments })),
                            React.createElement("div", { "data-testid": "div-d143ceed", className: "sm:col-span-1" },
                                React.createElement(AccountsPayable, { order: order, shipments: bookedShipments }))),
                        this.state.hasFinanceRole && (React.createElement("div", { "data-testid": "div-c12fb1a8", className: "my-6" },
                            React.createElement(AccessorialsList, { order: order, shipments: bookedShipments, onAddBulkAccessorials: this.handleAddBulkAccessorialsClick })))),
                    React.createElement(CargomaticCard, { dataTestId: "CargomaticCard-cc3f4c78", className: "sm:col-span-2", header: () => (React.createElement("h3", { "data-testid": "h3-a3aa483b", className: "my-0" }, t('AUDIT_HISTORY'))) },
                        React.createElement(AuditHistory, { audits: this.state.audits }))))),
            (order === null || order === void 0 ? void 0 : order.reference_numbers) && (React.createElement(EditReferenceNumbersModal, { reference_numbers: order.reference_numbers, shipper: order.shipper, isIntermodalShipmentType: true, page: "Orders", show: this.state.showEditReferenceNumbersModal, onSave: (references) => this.updateReferenceNumbers(references), onClose: () => {
                    this.setState({ showEditReferenceNumbersModal: false });
                } })),
            this.state.showArrivedModal && (React.createElement(ArrivedModal, { dataTestId: "ArrivedModal-c00242a0", show: this.state.showArrivedModal, onComplete: (workflow, meta) => {
                    OrdersActionCreators.transitionOrder(order, workflow, meta);
                }, onHide: () => this.setState({ showArrivedModal: false }) })),
            this.state.showBulkAddAccessorialsModal && (React.createElement(BulkAddAccessorialsModal, { show: this.state.showBulkAddAccessorialsModal, orderId: this.getOrder()._id, shipmentIds: this.getShipmentsEligibleForAccessorialsManagement().map((s) => s._id), onSave: this.handleBulkCreateAccessorials, onHide: () => {
                    this.setState({ showBulkAddAccessorialsModal: false });
                }, edit: false })),
            React.createElement("div", { "data-testid": "div-1d32f7ce", style: { height: 400 } }, "\u00A0")));
    }
}
Module.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    renderedInModal: PropTypes.bool,
};
export default withTranslation()(Module);
